import React from 'react';

function RatingStarsDisplay({ score, maxStars = 5, size = 14, activeColor = '#61E6BD', inactiveColor = '#BDBDBD' }) {
  return (
    <span className="rating-stars-display" style={{ display: 'inline-flex', gap: '2px' }}>
      {Array.from({ length: maxStars }, (_, i) => (
        <span
          key={i}
          style={{
            fontSize: size,
            color: i < score ? activeColor : inactiveColor,
            lineHeight: 1,
          }}
        >
          ★
        </span>
      ))}
    </span>
  );
}

export default RatingStarsDisplay;
